import React from 'react';
import PropTypes from "prop-types";

const FRACTION_DEFAULT_PLACEHOLDER = 'Write a number here...';
const FRACTION_DEFAULT_MAX_LENGTH = 10;


function FractionInput({fieldData, component_data, answer, fractionKey, fieldKey, onChange}) {
    if (!fieldData) {
        return null;
    }

    const maxLength = _.get(component_data, 'config.max_length', FRACTION_DEFAULT_MAX_LENGTH);
    const value = _.get(answer, ['answer_selections', fractionKey, fieldKey]);

    return (
        <input
            className="cc-fraction-input"
            type="text"
            value={value ?? ''}
            placeholder={fieldData.placeholder ?? FRACTION_DEFAULT_PLACEHOLDER}
            onChange={onChange}
            maxLength={maxLength}
            style={fieldData.style}
        />
    );
}

FractionInput.propTypes = {
    fieldData: PropTypes.object,
    component_data: PropTypes.object.isRequired,
    answer: PropTypes.object.isRequired,
    fractionKey: PropTypes.number.isRequired,
    fieldKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default FractionInput
